import { API_BASE_URL } from "./API_CONSTANT";
import { Http } from "./axios/http";

export const downloadPDF = async (
  downloadUrl: string,
  fileName?: string,
  params?: any
) => {
  try {
    if (!downloadUrl) return;

    const fullUrl = `${API_BASE_URL}${downloadUrl}`;

    const res = await Http.getFile(fullUrl, params);
    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const providedName = res?.headers["content-disposition"]
      ?.replace('"', "")
      ?.split("filename=")[1]
      ?.replace(".pdf", "")
      ?.trim();
    const filename = fileName || providedName;

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Erreur téléchargement PDF:", err);
  }
};
